import React from 'react';
import * as styles from './blocks.module.scss';
import Container from '../../components/container/container';
import Ethereum from '../../svg/chains/ethereum.svg';
import Bnb from '../../svg/chains/bnb.svg';
import Polygon from '../../svg/chains/polygon.svg';
import Avalanche from '../../svg/chains/avalanche.svg';
import Harmony from '../../svg/chains/harmony.svg';
import Fantom from '../../svg/chains/fantom.svg';
import Elysium from '../../svg/chains/elysium.svg';
import Arbitrum from '../../svg/chains/arbitrum.svg';
import Arthera from '../../svg/chains/arthera.svg';

const DEFAULTSTATE = {
    tokenCount: 0,
    marketCap: 0,
    expires: null,
};

const CHAINS = [
    {
        name: 'Ethereum',
        icon: <Ethereum />,
    },
    {
        name: 'Arbitrum',
        icon: <Arbitrum />,
    },
    {
        name: 'Polygon',
        icon: <Polygon />,
    },
    {
        name: 'Binance Smart Chain',
        icon: <Bnb />,
    },
    {
        name: 'Avalanche',
        icon: <Avalanche />,
    },
    {
        name: 'Fantom',
        icon: <Fantom />,
    },
    {
        name: 'Harmony',
        icon: <Harmony />,
    },
    {
        name: 'Elysium',
        icon: <Elysium />,
    },
    {
        name: 'Arthera',
        icon: <Arthera />,
    },
];

const Blocks = ({title, text, button}) => {
    // const [tvl, setTvl] = useState(DEFAULTSTATE);

    // const [date, setDate] = useState("");

    // const fetchCallback = useCallback((callback) => {
    //   fetch("https://platform-api.lossless.io/graphql", {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       query: `{
    //       checkTvl {
    //         market_cap
    //         tokenCount
    //       }}
    //     `,
    //     }),
    //   })
    //     .then((response) => response.json())
    //     .then((resultData) => {
    //       const resutlObject = {
    //         tokenCount: resultData.data.checkTvl.tokenCount,
    //         marketCap: resultData.data.checkTvl.market_cap,
    //         expires: new Date().getTime() + 2 * 60 * 1000,
    //       };
    //       localStorage.setItem("tvl", JSON.stringify(resutlObject));
    //       callback(resutlObject);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       callback(null);
    //     });
    // }, []);

    // useEffect(() => {
    //   const now = new Date();
    //   const dateOptions = {
    //     month: "long",
    //     day: "numeric",
    //     year: "numeric",
    //   };

    //   setDate(now.toLocaleDateString("en-US", dateOptions));
    // }, []);

    // useEffect(() => {
    //   const localStorageTvlStr = localStorage.getItem("tvl");

    //   if (localStorageTvlStr) {
    //     const parseTvl = JSON.parse(localStorageTvlStr);

    //     setTvl(parseTvl);

    //     if (new Date().getTime() > parseTvl.expires) {
    //       fetchCallback((result) => setTvl(result ?? DEFAULTSTATE));
    //     }
    //   } else {
    //     fetchCallback((result) => setTvl(result ?? DEFAULTSTATE));
    //   }
    // }, [fetchCallback]);

    return (
        <section className={styles.blocks}>
            <Container>
                <div className={styles.blocksWrap}>
                    <div className={styles.blocksItem}>
                        <h3>Supported chains</h3>
                        <div className={styles.blockItemContent}>
                            {CHAINS.map((chain, index) => {
                                return (
                                    <div className={styles.blockItemTooltipTrigger}>
                                        {chain.icon}
                                        <div className={styles.blockItemTooltip}>{chain.name}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className={styles.blocksItem}>
                        <h3>Protected Contracts</h3>
                        <div className={styles.blockItemContent}>
                            <p>2000+</p>
                        </div>
                    </div>
                    <div className={styles.blocksItem}>
                        <h3>Scanned Transactions</h3>
                        <div className={styles.blockItemContent}>
                            <p>3+ Billion</p>
                            {/* <div className={styles.blockItemTooltipTrigger}>
                  <WarningIcon />
                  <div className={styles.blockItemTooltip}>
                    Total US dollar value protected by Lossless protocol.
                    Updated {date}
                  </div>
                </div> */}
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default Blocks;
